const id_master_whs_setting = {
    "": "pengaturan gudang",
    add: "tambah gudang",
    edit: "ubah gudang",
    name: "nama gudang",

    label: {
        coa_supply: "COA Persediaan",
        coa_sales: "COA Penjualan",
    },

    error: {
        address: "Alamat gudang tidak boleh kosong",
        email: "Email gudang tidak boleh kosong",
        email_valid: "Email gudang tidak valid",
        name: "Nama gudang tidak boleh kosong",
        phone: "Nomor telepon gudang tidak boleh kosong",
        create: "Gagal membuat gudang",
        edit: "Gagal mengubah gudang",
    },

    success: {
        create: "Berhasil membuat gudang",
        edit: "Berhasil mengubah gudang",
    }
}

export default id_master_whs_setting;